<template>
  <div class="integralTask">
    <div class="peak">
      <img src="@/assets/images/top.png" alt="" />
      <h4 class="title">积分任务</h4>
    </div>
    <div class="background" :class="{ active: selectBg }">
      <img
        :src="pageConfig.integralTask.backgroundSrc"
        @click="selectModule('background')"
      />
      <!-- 控制条 -->
      <div class="controlBarWrap" v-show="bgControlState">
        <ul class="controlList">
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe68f;</i>
          </li>
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe691;</i>
          </li>
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe690;</i>
          </li>
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe692;</i>
          </li>
        </ul>
      </div>
    </div>
    <!-- 等级积分模块 -->
    <div
      class="scoreSet"
      :class="{ mrb10: !pageConfig.integralTask.pageComponents[0].hideGaps }"
      @click="selectModule(pageConfig.integralTask.pageComponents[0])"
    >
      <div
        class="setWrap"
        :class="{ active: pageConfig.integralTask.pageComponents[0].select }"
      >
        <div class="left">
          <span>当前积分</span>
          <span>2563</span>
        </div>
        <div class="right">
          <img
            :src="pageConfig.integralTask.uploadIcon"
            class="uploadImg"
            alt=""
          />
          活动记录
        </div>
      </div>
      <!-- 控制条 -->
      <div
        class="controlBarWrap"
        v-show="pageConfig.integralTask.pageComponents[0].select"
      >
        <ul class="controlList">
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe68f;</i>
          </li>
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe691;</i>
          </li>
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe690;</i>
          </li>
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe692;</i>
          </li>
        </ul>
      </div>
    </div>

    <!-- 列表 -->
    <transition-group name="flip-list" tag="ul" ref="list" class="list">
      <template v-for="(data, index) in pageConfig.integralTask.pageComponents">
        <!-- 活动列表 -->
        <li
          v-if="data.id == 4"
          :key="'component' + data.id + 'Task'"
          :data-id="data.id"
          :class="{ active: data.select }"
        >
          <div
            class="activityList"
            :class="{ active: data.select, mrb10: !data.hideGaps }"
            :key="'component' + index + 'task'"
            @click="selectModule(data)"
          >
            <template v-for="item in pageConfig.integralTask.activityList">
              <div class="activityItem" :key="item.id" v-if="item.visibility">
                <img :src="item.imageUrl" class="activityIcon" />
                <div class="activityInfo">
                  <span class="name">{{ item.activityName }}</span>
                  <span class="desc">{{ item.desc }}</span>
                  <span class="time"
                    >活动日期:
                    {{ moment(item.updateTime).format("YYYY.MM.DD") }} -
                    {{ moment(item.endTime).format("YYYY.MM.DD") }}</span
                  >
                </div>
                <div class="joinBtn">立即参加</div>
              </div>
            </template>
          </div>
          <!-- 控制条 -->
          <div class="controlBarWrap" v-show="data.select">
            <ul class="controlList">
              <li class="control">
                <i class="iconfont">&#xe68f;</i>
              </li>
              <li class="control">
                <i class="iconfont">&#xe691;</i>
              </li>
              <li class="control">
                <i class="iconfont">&#xe690;</i>
              </li>
              <li class="control" @click="handleControl('delete', data)">
                <i class="iconfont">&#xe692;</i>
              </li>
            </ul>
          </div>
        </li>
      </template>
    </transition-group>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Sortable from "sortablejs";

export default {

  computed: {
    ...mapState(["pageConfig"]),
  },
  data() {
    return {
      selectBg: false,
      bgControlState: false,
      domList: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapMutations([
      "componentListChange",
      "addComponent",
      "switchConfigState",
      "toppingComponent",
      "delComponent",
    ]),
    init() {
      let self = this;
      let options = {
        animation: 500,
        dataIdAttr: "data-id",
        filter: ".filter",
        sort: false,
        group: { name: "list", pull: false, put: true },
        onAdd(evt) {
          const arr = sortList.toArray();
          self.componentListChange(+evt.oldIndex);
          self.addComponent(arr);
          self.domList.push({
            id: evt.clone.dataset.id,
            dom: evt.clone,
          });
          evt.clone.className = "wrap";
          evt.item.remove();
        },
        onEnd: function(evt) {},
      };
      var sortList = Sortable.create(this.$refs.list.$el, options);
    },
    selectModule(data) {
      if (data === "background") {
        if (this.selectBg) return;
        this.selectBg = true;
        this.bgControlState = true;
        this.pageConfig.integralTask.pageComponents.forEach(
          (item) => (item.select = false)
        );
        this.switchConfigState(0);
      } else {
        this.selectBg = false;
        this.bgControlState = false;
        if (data.select) return;
        this.pageConfig.integralTask.pageComponents.forEach(
          (item) => (item.select = false)
        );
        data.select = true;
        this.switchConfigState(data.id);
      }
    },
    handleControl(type, data) {
      switch (type) {
        case "topping":
          this.toppingComponent(data.id);
          break;
        case "moveUp":
          this.upAndDown({ id: data.id, type: "moveUp" });
          break;
        case "moveDown":
          this.upAndDown({ id: data.id, type: "moveDown" });
          break;
        case "delete":
          this.delComponent(data.id);
          const obj = this.domList.find((item) => item.id == data.id);
          this.domList = this.domList.filter((item) => item.id != data.id);
          // 将左侧组件恢复可拖拽状态
          if (obj) obj.dom.className = "wrap draw";
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.integralTask {
  flex: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .peak {
    position: relative;
    width: 100%;
    img {
      width: 100%;
    }
    .title {
      position: absolute;
      left: 50%;
      top: 60%;
      transform: translate(-50%);
      margin: 0;
      text-align: center;
      font-size: 20px;
      font-weight: 600;
      color: #333;
    }
  }
  .background {
    position: relative;
    box-sizing: border-box;
    img {
      width: 100%;
      height: 98px;
    }
    &.active {
      border: 2px dashed #4878ff;
    }
  }
  .scoreSet {
    box-sizing: border-box;
    padding: 0 18px;
    transform: translateY(-50%);
    .setWrap {
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      padding: 18px 0;
      height: 110px;
      background-color: #fff;
      border-radius: 6px;
      &.active {
        border: 2px dashed #4878ff;
      }
    }
    .left,
    .right {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .left {
      flex-direction: column;
      border-right: 1px solid #ddd;
      span {
        &:first-child {
          color: #666;
          font-size: 13px;
          font-weight: 500;
        }
        &:last-child {
          margin-top: 4px;
          color: #dc4e40;
          font-size: 20px;
          font-weight: bold;
        }
      }
    }
    .right {
      color: #000000;
      font-size: 15px;
      font-weight: 500;
      .uploadImg {
        margin-right: 8px;
        height: 32px;
      }
    }
  }
  .list {
    flex: 1;
    transform: translateY(-55px);
    li {
      position: relative;
    }
    .activityList {
      box-sizing: border-box;
      margin-left: 18px;
      margin-right: 18px;
      background-color: #fff;
      box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
      &.active {
        border: 2px dashed #4878ff;
      }
      .activityItem {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 30px 0;
        margin: 0 14px;
        border-bottom: 1px solid #e6e6e6;
        &:last-child {
          border: none;
        }
        .activityIcon {
          flex-shrink: 0;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          margin-right: 14px;
        }
        .activityInfo {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          text-align: left;
          .name {
            color: #000;
            font-size: 15px;
            font-weight: bold;
          }
          .desc {
            margin: 6px 0;
            color: #999999;
            font-size: 12px;
            font-weight: 400;
          }
          .time {
            color: #f87541;
            font-size: 11px;
            font-weight: 400;
          }
        }
        .joinBtn {
          flex-shrink: 0;
          width: 106px;
          height: 38px;
          line-height: 38px;
          text-align: center;
          border-radius: 35px;
          background-color: #dc4e40;
          cursor: pointer;
          color: #fff;
          font-size: 11px;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
